import { useEffect, useMemo, useReducer, useState } from "react";
import Service from "../../Service/http";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import EntityDataGrid from "../CustomComponents/EntityDataGrid";
import { Tab } from "../../store/Actions";
import CustomSnackbar from "../CustomComponents/CustomSnackbar";
import CustomConfirmDialog from "../CustomComponents/CustomConfirmDialog";
import PdfViewerDialog from "../CustomComponents/PdfViewerDialog";

const fieldConfigs = [
  { field: "title", width: 250 },
  { field: "pi", width: 150 },
  { field: "co_pi", width: 210 },
  { field: "dept", width: 120 },
  { field: "amount", width: 140 },
  { field: "scheme", width: 160 },
  { field: "year", width: 120 },
  { field: "duration", width: 120 },
];

const initialState = {
  allData: [],
  data: [],
  pageNo: 1,
  perPage: 10,
  color: "",
  background: "#81C784",
  textColor: "",
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_ALL_DATA": {
      const docs = action.payload.docs || [];
      return { ...state, allData: docs, data: docs };
    }
    case "REMOVE_ITEM": {
      const id = action.id;
      const allData = state.allData.filter((d) => d._id !== id);
      const data = state.data.filter((d) => d._id !== id);
      return { ...state, allData, data };
    }
    default:
      return state;
  }
};

function Research() {
  const service = useMemo(() => new Service(), []);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const verify = useSelector((state) => state.verify);
  const loggedIn = useSelector((state) => state.logged);
  const isAdmin = useSelector((state) => state.isAdmin);
  const isSuperAdmin = useSelector((state) => state.isSuperAdmin);

  const [titles, setTitles] = useState([]);
  const [state, localDispatch] = useReducer(reducer, initialState);
  const [snack, setSnack] = useState({ open: false, status: 0, message: "" });
  const [isLoading, setIsLoading] = useState(true);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: "",
    content: "",
    onConfirm: null,
  });
  const [pdfViewer, setPdfViewer] = useState({ open: false, url: "", title: "" });

  const handlePdfClose = () => {
    setPdfViewer({ open: false, url: "", title: "" });
  };

    const handleView = (row) => {
    console.log('Row',row)
    if (!row || !row.fileName) {
      setSnack({
        open: true,
        message: "No document Uploaded",
        status: 400,
      });
      return;
    }
    const fileUrl = service.getFileUrl(row.fileName);
    setPdfViewer({ open: true, url: fileUrl, title: row.title });
  };


  const handleDelete = (data) => {
    setConfirmDialog({
      open: true,
      title: "Delete research project",
      content:
        "This action will permanently delete \"" +
        data.title +
        "\" research project.",
      onConfirm: () => {
        setConfirmDialog((prev) => ({ ...prev, open: false }));
        service
          .delete("api/research/data/" + data._id)
          .then(() => {
            localDispatch({ type: "REMOVE_ITEM", id: data._id });
            setSnack({
              open: true,
              status: 200,
              message: `Deleted ${data.title} research project.`,
            });
          })
          .catch((err) => {
            console.error("ERROR", err);
            setSnack({
              open: true,
              status: 500,
              message: "Error while deleting the research project",
            });
          });
      },
    });
  };

  const handleEdit = (row) => {
    navigate("../insertResearch", {
      state: { edit: true, researchData: row },
    });
  };

  useEffect(() => {
    dispatch(Tab("research"));
    if (!loggedIn) {
      navigate("../");
      if (!verify) navigate("../verify");
      return;
    }

    if (titles.length === 0) {
      service
        .get("api/research/titles")
        .then((res) => setTitles(res))
        .catch((error) => {
          console.error("ERROR", error);
          setSnack({ open: true, status: 500, message: "Failed to load research titles" });
        });
    }

    setIsLoading(true);
    service
      .get("api/research/data")
      .then((json) => {
        const normalized = (json.docs || []).map((d) => ({
          ...d,
          dept: Array.isArray(d.dept) ? d.dept.join(", ") : d.dept,
        }));
        localDispatch({ type: "SET_ALL_DATA", payload: { docs: normalized } });
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setSnack({ open: true, status: 500, message: "Error while fetching research projects" });
        setIsLoading(false);
      });
  }, [dispatch, loggedIn, navigate, service, titles.length, verify]);

  if (!loggedIn) return null;

  return (
    <>
      <div
        className="p-3"
        style={{
          height: state.data.length > 0 && state.data.length < 10 ? "90vh" : "100%",
          width: "99vw",
          backgroundColor: "#c5d299",
        }}
      >
        <PdfViewerDialog
                open={pdfViewer.open}
                onClose={handlePdfClose}
                title={pdfViewer.title}
                fileUrl={pdfViewer.url}
              />

        <EntityDataGrid
          data={state.data}
          pageNo={state.pageNo}
          perPage={state.perPage}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          isAdmin={isAdmin}
          isSuperAdmin={isSuperAdmin}
          color={state.color}
          background={state.background}
          textColor={state.textColor}
          fieldConfigs={fieldConfigs}
          type={"ResearchKey"}
          loading={isLoading}
            handleView={handleView}
        />
      </div>
      <CustomSnackbar
        open={snack.open}
        status={snack.status}
        message={snack.message}
        handleClose={() => setSnack((s) => ({ ...s, open: false }))}
      />
      <CustomConfirmDialog
        open={confirmDialog.open}
        title={confirmDialog.title}
        content={confirmDialog.content}
        handleClose={() =>
          setConfirmDialog((prev) => ({ ...prev, open: false }))
        }
        handleConfirm={() => {
          if (confirmDialog.onConfirm) {
            confirmDialog.onConfirm();
          }
        }}
      />
    </>
  );
}

export default Research;